// src/Views/HomePage.js
import React, { useState } from 'react';
import './HomePage.css';
import MathCounter from '../assets/counter-component/MathCounter';

const HomePage = () => {
    const [isBlue, setIsBlue] = useState(false);

    const toggleColor = () => {
        setIsBlue(!isBlue);
    };

    return (
        <div className="cafe-homepage">
            <h1>Welcome to Omida AI</h1>
            <p>Your go-to solution for AI-driven web applications.</p>
            <MathCounter />
            <div className={`cafe-color-box ${isBlue ? 'cafe-blue' : 'cafe-red'}`}></div>
            <button className="cafe-button" onClick={toggleColor}>Change Color</button>
        </div>
    );
};

export default HomePage;